<template>
  <v-select
    v-model="empresa"
    name="empresa"
    label="Empresa"
    :items="orderedEmpresas"
    item-value="url"
    item-text="nome"
    :outlined="tipo === 'outlined'"
    class="mb-0 pb-0"
    no-data-text="Nenhuma empresa disponível"
    :loading="loading"
    @change="$emit('change')"
  />
</template>

<script>
  import Firestore from '@/Firestore.js';
  import TourService from '@/services/TourService';
  import ConfiguracoesService from '@/services/ConfiguracoesService.js';
  import PerfisService from '@/services/PerfisService';

  export default {
    props: {
      tipo: {
        type: String,
        default: 'solo'
      },
      todas: {
        type: Boolean,
        default: false
      }
    },

    emits: ['change'],

    data: () => ({
      empresa: '',
      empresas: [],
      loading: false
    }),

    computed: {
      orderedEmpresas() {
        const empresas = this.empresas;
        return empresas.sort((a, b) => (a.nome < b.nome ? -1 : 1));
      },

      siglaEmpresa() {
        return this.$store.getters.getSiglaEmpresa;
      }
    },

    mounted() {
      this.empresa = this.$store.getters.getEmpresa;
      if (!this.todas) {
        this.getUsuarioEmpresas();
      } else {
        this.getEmpresas();
      }
    },

    methods: {
      getEmpresas() {
        this.loading = true;

        Firestore.collection('empresas')
          .orderBy('nome')
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              if (doc.data().sigla !== 'BRD') {
                this.empresas.push({
                  id: doc.id,
                  nome: doc.data().nome,
                  url: doc.data().url,
                  sigla: doc.data().sigla,
                  nome_hexa: doc.data().nome_hexa
                });
              }
            });
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error('Erro ao recuperar empresas.', '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      },

      async getUsuarioEmpresas() {
        let userUid = this.$store.getters.getUserUid;
        const userRef = Firestore.collection('usuarios').doc(userUid);

        this.loading = true;

        await Firestore.collection('usuarios_empresas')
          .where('usuario_id', '==', userRef)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              Firestore.collection('empresas')
                .doc(doc.data().empresa_id.id)
                .get()
                .then((docEmpresas) => {
                  this.empresas.push({
                    id: docEmpresas.id,
                    nome: docEmpresas.data().nome,
                    url: docEmpresas.data().url,
                    sigla: docEmpresas.data().sigla,
                    nome_hexa: docEmpresas.data().nome_hexa
                  });
                });
            });
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error('Erro ao recuperar empresas.', '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      },

      async changeSelectedEmpresa() {
        this.loading = true;

        this.$store.dispatch('setEmpresa', this.empresa);

        this.empresas.forEach((empresa) => {
          if (empresa.url == this.empresa) {
            this.$store.dispatch('setIdEmpresaFirebase', empresa.id);
            this.$store.dispatch('setSiglaEmpresa', empresa.sigla);
          }
        });
        this.$store.dispatch('setPusherChannel', await this.getPusherChannel());

        await this.$store.dispatch('setUserIdHexaToVuex');

        const tour_info = await TourService.getRelacaoTourUser();
        this.$store.dispatch('setTour', tour_info);

        const modulos = await PerfisService.getModulosLiberados();
        this.$store.dispatch('setModulosPerfisLiberados', {
          categorias: modulos.categorias,
          ferramentas: modulos.ferramentas,
          ferramentas_liberadas: modulos.ferramentas_liberadas,
          tabelas_liberadas: modulos.tabelas_liberadas,
          conformidades_obras_testes_liberados: modulos.conformidades_obras_testes_liberados
        });

        this.loading = false;
      },

      getPusherChannel() {
        return ConfiguracoesService.getNomeEmpresa()
          .then((response) => response.data.nome_empresa.toLowerCase())
          .catch(() => this.$toast.error('Erro ao recuperar canal do pusher.', '', { position: 'topRight' }));
      }
    }
  };
</script>
